<template>
  <ui-menu-base-trigger @focus="handleFocus">
    <template #default="{ openMenu }">
      <button
        ref="buttonRef"
        type="button"
        class="flex grow items-center gap-2 rounded border px-3 py-2 transition-colors"
        :data-testid
        :disabled="disabled"
        :class="[
          active &&
            'border-button-primary-outline shadow-[0_0_4_0_rgba(59,76,191,0.6)] hover:border-button-primary-outline',
          !active && !disabled && 'border-gray-30 hover:border-gray-40',
          small && 'h-8 text-xs',
          !small && 'h-10 text-sm',
          disabled && 'pointer-events-none cursor-not-allowed border-gray-20 bg-gray-20',
          !disabled && 'bg-gray-10',
          textClass,
        ]"
        @click="handleOpen(openMenu)"
        @keydown.enter="handleOpen(openMenu)"
        @keydown.down="handleKeydownDown"
        @keydown.up="handleKeydownUp"
        @keydown.esc="handleKeydownEsc"
      >
        <div class="flex grow items-center gap-2 leading-none">
          <slot name="icon" />
          <slot />
        </div>
        <double-caret-icon class="icon-m" :class="[disabled && 'text-gray-50', !disabled && 'text-gray-60']" />
      </button>
    </template>
  </ui-menu-base-trigger>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import DoubleCaretIcon from '../../UiDropdownV2/assets/double-caret.svg'
import UiMenuBaseTrigger from './UiMenuBaseTrigger.vue'

const props = defineProps<{
  active?: boolean
  small?: boolean
  disabled?: boolean
  placeholder?: boolean
  dataTestid?: string
}>()

const emit = defineEmits<{
  'keydown:down': [event: KeyboardEvent]
  'keydown:up': [event: KeyboardEvent]
  'keydown:esc': [event: KeyboardEvent]
}>()

const buttonRef = ref<HTMLButtonElement | null>(null)

const textClass = computed(() => {
  if (props.disabled) return 'text-gray-60'
  if (props.placeholder) return 'text-gray-50'
  return 'text-gray-90'
})

const handleOpen = (openMenu: () => void) => {
  if (props.disabled) return

  openMenu()
}

const handleKeydownDown = (event: KeyboardEvent) => {
  if (!props.disabled) emit('keydown:down', event)
}

const handleKeydownUp = (event: KeyboardEvent) => {
  if (!props.disabled) emit('keydown:up', event)
}

const handleKeydownEsc = (event: KeyboardEvent) => {
  if (!props.disabled) emit('keydown:esc', event)
}

const handleFocus = () => {
  buttonRef.value?.focus()
}
</script>
